import { createFileRoute } from "@tanstack/react-router";
import { DashboardShell, PlaceholderCard } from "@/components/DashboardShell";
import { SUPER_ADMIN_NAV } from "@/lib/nav";

export const Route = createFileRoute("/_authenticated/super-admin/invoice-settings")({
  head: () => ({
    meta: [
      { title: "Invoice settings · Landoo Super Admin" },
      {
        name: "description",
        content: "Global invoice numbering, tax placeholders and branding rules.",
      },
    ],
  }),
  component: () => (
    <DashboardShell title="Invoice settings" role="Super Admin" items={SUPER_ADMIN_NAV}>
      <div className="grid gap-3 md:grid-cols-2">
        <PlaceholderCard
          title="Invoice numbering"
          description="Prefix and sequence rules applied to partner invoices."
        />
        <PlaceholderCard
          title="Tax configuration"
          description="Tax fields are placeholders; no tax engine is connected."
        />
        <PlaceholderCard
          title="Invoice branding"
          description="Platform logo and footer applied to generated invoices."
        />
        <PlaceholderCard
          title="Invoice audit"
          description="Platform-wide invoice history and exports."
        />
      </div>
    </DashboardShell>
  ),
});
